package com.wintermar.inspection.core.ui.component.input.util

import org.jetbrains.compose.resources.DrawableResource

data class InputStateModel(
    val value: String = "",
    val label: String = "",
    val placeholder: String = "",
    val informationMessage: String = "",
    val type: InputType = InputType.TEXT,
    val multiLine: Boolean = false,
    val leadingIcon: DrawableResource? = null,
    val trailingIcon: DrawableResource? = null,
    val trailingIconClickable: Boolean = false,
    val autoTrim: Boolean = true,
    val validation: InputValidationModel = InputValidationModel()
) {
    fun defaultMandatory(
        showAsterisk: Boolean = true,
        mandatoryMessage: String = "",
        additionalTypes: List<InputValidationType> = listOf()
    ) = copy(
        validation = validation.copy(
            mandatory = true,
            showAsterisk = showAsterisk,
            mandatoryMessage = mandatoryMessage,
            types = listOf(
                InputValidationType.MANDATORY
            ) + additionalTypes
        )
    )
}

data class InputValidationModel(
    val disabled: Boolean = false,
    val mandatory: Boolean = false,
    val minChar: Int? = null,
    val maxChar: Int? = null,
    val showAsterisk: Boolean = true,
    val mandatoryMessage: String = "",
    val types: List<InputValidationType>? = null
)
